import { LocalParticipant, Room } from "@domain";
import {
  IBlocSyncInteractor,
  SyncInteractor
} from "@kernel/frontend-react-app";

export interface CreateRoomInteractorProps {
  roomName: string;
  localParticipant: LocalParticipant;
}

export class CreateRoomInteractor
  extends SyncInteractor<CreateRoomInteractorProps, Room>
  implements IBlocSyncInteractor<CreateRoomInteractorProps, Room>
{
  public execute({
    roomName,
    localParticipant
  }: CreateRoomInteractorProps): Room {
    const room = Room.createEmpty(roomName);
    room.joinLocalParticipant(localParticipant);
    return room;
  }

  public static create(): CreateRoomInteractor {
    return new CreateRoomInteractor();
  }
}
